// src/components/JobInterview.js
import AlumniNetwork from './allumini/AlumniNetwork';
import AlumniRegistrationForm from './allumini/AlluminiRegistrationForm';
import React from 'react';
const AlumniNetworks = () => {
  return (
    <div>
      <AlumniNetwork />
      <AlumniRegistrationForm />
    </div>
  );
};

export default AlumniNetworks;
